// El número compuesto con el que Business Central identifica una apertura y un
// cierre de caja, leído en un solo sitio.
//
// No es un número: es una clave concatenada con punto y coma, y con **dos
// formatos distintos** que hay que no confundir:
//
// - Apertura: `TPV;Caja;Fecha`          → `"MALL DEL SOL;PVMDSC3;07/08/26"`
// - Cierre:   `Tienda;TPV;Fecha;Hora`   → `"MALL DEL SOL;PVMDSC3;07/08/26;17:15"`
//
// El terminal lo parte porque no le queda otra: la entidad de aperturas no trae
// un campo de tienda, y la de cierres no trae hora --no existe `HoraDeCierre` en
// el esquema--, así que los dos datos sólo viajan dentro del número.
//
// Estaba partido a mano en cinco sitios, cada uno con su índice escrito
// suelto. Un índice equivocado no falla: devuelve el segmento de al lado, que
// también es una cadena con pinta de válida --la tienda por la caja, por
// ejemplo-- y nadie se entera hasta que algo no casa. Acá está una vez, con el
// formato escrito al lado.
//
// **Esto no arregla el fondo**, que es depender de una clave concatenada: eso
// necesita que Business Central publique los campos por separado. Lo que hace es
// dejar un solo sitio donde cambiarlo el día que los publique.

const segmentos = (no) =>
  String(no ?? "")
    .split(";")
    .map((parte) => parte.trim());

/**
 * La tienda, que es el primer segmento en los dos formatos.
 *
 * @param {string} no
 * @returns {string|null}
 */
export const tiendaDelNumero = (no) => segmentos(no)[0] || null;

/**
 * La caja, que es el segundo segmento en los dos formatos.
 *
 * @param {string} no
 * @returns {string|null}
 */
export const cajaDelNumero = (no) => segmentos(no)[1] || null;

/**
 * La hora del cierre, que es el último segmento --y sólo la hay en el número de
 * un cierre--.
 *
 * Se comprueba que parezca una hora antes de devolverla: el número de una
 * apertura termina en la fecha, y darla por hora dejaría un cierre emparejado
 * con la apertura equivocada.
 *
 * @param {string} no
 * @returns {string|null} `HH:mm`, o `null` si el último segmento no es una hora.
 */
export const horaDelCierre = (no) => {
  const partes = segmentos(no);
  const ultimo = partes[partes.length - 1];
  return /^\d{1,2}:\d{2}$/.test(ultimo) ? ultimo : null;
};
